import styled from '@emotion/styled/macro';
import BareList from 'src/primitives/BareList';

export const ErrorList = styled(BareList)`
  margin: 0;
`;
